// extracted by mini-css-extract-plugin
export var footerWrapper = "Layout-module--footerWrapper--dbcf5";
export var layoutWrapper = "Layout-module--layoutWrapper--f04c7";
export var mainWrapper = "Layout-module--mainWrapper--d8ea2";